export default {
  common: {
    cancel: 'mégse',
  },

  usermenu: {
    my_profile: 'Profilom',
    billing_info: 'Számlázási adatok',
    change_password: 'Jelszó módosítása',
    logout: 'Kijelentkezés',
  },

  pages: {
    login: {
      email: 'Email cím',
      password: 'Jelszó',
      login: 'Bejelentkezés',
      required: {
        please_input_your_e_mail: 'Kérem adja meg az e-mail címét!',
        please_input_your_password: 'Kérem adja meg a jelszavát!',
      },
    },

    signup: {
      email: 'Email',
      password: 'Jelszó',
      show: 'megjelenít',
      hide: 'elrejt',
      signup: 'Regisztráció',
      required: {
        please_input_your_e_mail: 'Kérem adja meg az e-mail címét!',
        please_input_your_password: 'Kérem adja meg a jelszavát!',
        the_input_is_not_valid_e_mail: 'Kérem érvényes e-mail címet adjon meg!',
      },
    },

    profile: {
      changePassword: {
        current_password: 'Jelenlegi jelszó',
        new_password: 'Új jelszó',
        retype_password: 'Új jelszó megerősítése',
        change_password: 'Jelszó módosítása',
      },

      billingInfo: {
        szaml_nev: 'Számlázási név',
        szaml_titulus: 'Titulus',
        szaml_vezeteknev: 'Vezetéknév',
        szaml_keresztnev: 'Keresztnév',
        szaml_cim: 'Számlázási cím',
        szaml_irsz: 'Irányítószám',
        szaml_telepules: 'Település',
        szaml_adoszam: 'Adószám',
        save: 'Mentés',
      },

      forgotten: {
        restore: 'Jelszó helyreállítása',
      },
    },

    dashboard: {
      read_more: 'Tovább',
    },
  },
};



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/locales/hu.js